import React, { useEffect, useState, useRef } from 'react';
import { Form, Input, Select, Button, Tag, Row, Col } from 'antd';
import ValidatorHelper from '../helpers/ValidatorHelper';
import PictureUpload from '../file-upload/PictureUpload';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function NewTicketForm() {
    const general = useGeneralStore();
    const { Search } = Input;
    const pictureUploader = useRef(null);
    const [form] = Form.useForm();
    const { TextArea } = Input;

    const contactType = general.contact.ContactUsType;
    const loading = general.contact.loading;
    const searchLoading = general.userInfo.loading;
    const postTicketLoading = general.newTicket.loading;
    const userPurchases = general.userInfo.data.userPurchases;
    const fullname = general.userInfo.data.fullname;

    const [showFullName, setShowFullName] = useState(false);
    const [selectInsurance, setSelectInsurance] = useState(true);


    useEffect(() => {
        general.getContact(contactType);
        fullname && setShowFullName(true)
        userPurchases && setSelectInsurance(false);
    }, [fullname, userPurchases]);

    function onFinish(values) {
        const attachFile = pictureUploader.current.state.fileList;

        var dataToSend = new FormData();

        dataToSend.append("message", values.message);
        dataToSend.append("username", values.userName);
        dataToSend.append("contactTypeId", values.typeId);
        if (values.InsuranceRequestId)
            dataToSend.append("insuranceRequestId", values.InsuranceRequestId);
        else
            dataToSend.append("insuranceRequestId", 0);

        if (attachFile.length > 0) {

            attachFile.map((file, index) => {
                dataToSend.append(file.name, file);
            })
        }

        general.postNewTicket(dataToSend);
        pictureUploader.current.setState({ fileList: [] });
        form.resetFields();
        setShowFullName(false);
        setSelectInsurance(true);


    }

    function onFinishFailed(errorInfo) {
        form.scrollToField(errorInfo.errorFields[0].typeId, {
            scroll: {
                offsetTop: 65,
            },
        });
    }

    const handleSubmit = (values) => {
        setShowFullName(false);
        setSelectInsurance(true);
        if (values) {
            general.getTicketUserInfo(values);
        }
    }

    return (
        <div>
            <Form
                form={form}
                className="form-style"
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                hideRequiredMark
            >
                <Row gutter={[8, 8]}>
                    <Col lg={24}>
                        <Form.Item
                            label="نام کاربری"
                            name="userName"
                            rules={ValidatorHelper.required("نام کاربری")}
                        >
                            <Search
                                className="search"
                                placeholder=""
                                enterButton="جستجو"
                                size="large"
                                loading={searchLoading}
                                onSearch={handleSubmit}
                                onChange={() => setSelectInsurance(true)}
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={24}>
                        {showFullName && <Tag color="#5ec393">{fullname}</Tag>}
                    </Col>
                    <Col lg={12}>
                        < Form.Item
                            label="انتخاب بیمه نامه"
                            name="InsuranceRequestId"
                        // rules={ValidatorHelper.required("بیمه نامه")}
                        >
                            <Select
                                disabled={selectInsurance}
                                loading={loading}
                                placeholder="بیمه نامه مورد نظر خود را انتخاب کنید."
                            >
                                {userPurchases &&
                                    userPurchases?.map((item) => (
                                        <Select.Option key={item.Id} value={item.Id}>
                                            {item.Title}
                                        </Select.Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={12}>
                        <Form.Item
                            label="موضوع درخواست"
                            name="typeId"
                        // rules={ValidatorHelper.required("موضوع درخواست")}
                        >
                            <Select loading={loading}
                            >
                                {contactType &&
                                    contactType?.ContactUsType?.map((item) => (
                                        <Select.Option key={item.Id} value={item.Id}>
                                            {item.Title}
                                        </Select.Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col lg={24}>
                        <Form.Item
                            label="شرح درخواست"
                            name="message"
                            rules={ValidatorHelper.required("شرح درخواست")}
                        >
                            <TextArea
                                className="animated fadeIn"
                                autoSize={{ minRows: 4, maxRows: 6 }}
                                maxLength={3000}
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={24}>
                        <Form.Item>
                            <PictureUpload ref={pictureUploader} count={5} />
                        </Form.Item>
                    </Col>
                    <Col lg={24}>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="primary-button"
                                loading={postTicketLoading}
                                block >
                                ارسال
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div >
    );
}
